import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  GET_LICENSE_BY_ID,
  ADD_NEW_SPEC_MARK,
  ADD_NEW_CONF_MARK,
  REVOKE_LICENSE,
  CLEAR_LICENSE_INFO,
  SET_PAGE_INDEX_LICENSE,
  SET_SEARCH_PARAMS_LICENSE,
} from "../types";

import {
  MAIN_URL,
  PORT,
  API_GET_LICENSE_INFO_CARD,
  API_ADD_NEW_SPECIAL_MARK,
  API_ADD_NEW_CONF_MARK,
  API_LICENSE_CANCELLATION,
} from "../../constants/constants";

export function getLicenseById(id) {
  return async (dispatch) => {
    const response = await fetchWithToken(MAIN_URL + PORT + API_GET_LICENSE_INFO_CARD + id);
    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: GET_LICENSE_BY_ID,
        data: data,
      });
    }
  };
}

export function addNewSpecialMark(newMark) {
  return {
    type: ADD_NEW_SPEC_MARK,
    data: newMark,
  };
}

export function addNewConfMark(newMark) {
  return {
    type: ADD_NEW_CONF_MARK,
    data: newMark,
  };
}

export function revokeLicense(data) {
  return {
    type: REVOKE_LICENSE,
    data: data,
  };
}

export function clearLicenseInfo() {
  return {
    type: CLEAR_LICENSE_INFO,
    data: {},
  };
}

export function setSearchParamsLicenses(params) {
  return {
    type: SET_SEARCH_PARAMS_LICENSE,
    data: params,
  };
}

export function setPageIndexLicenses(index) {
  return {
    type: SET_PAGE_INDEX_LICENSE,
    data: index,
  };
}
